import React, { createContext, useContext, useState, useEffect, ReactNode, useCallback } from "react";
import en from "../assets/locale/en.json";
import th from "../assets/locale/th.json";

type Language = "en" | "th";

interface LanguageContextProps {
  language: Language;
  translations: Record<string, any>;
  switchLanguage: (lang: Language) => void;
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>("th");
  const [translations, setTranslations] = useState<Record<string, any>>(th);

  useEffect(() => {
    const loadTranslations = () => {
      if (language === "th") {
        setTranslations(th);
      } else {
        setTranslations(en);
      }
    };
    loadTranslations();
  }, [language]);

  const switchLanguage = useCallback((lang: Language) => {
    setLanguage(lang);
  }, []);

  return (
    <LanguageContext.Provider value={{ language, translations, switchLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = (): LanguageContextProps => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
};
